import { Flex, Text } from '@mantine/core'
import { IconSettings } from '@tabler/icons';
import { MAIN_DARK_PRIMARY } from '../../../../constants/colors';

interface ManageButtonProps {
  setIsManagingFilters: React.Dispatch<React.SetStateAction<boolean>>;
}

const ManageButton: React.FC<ManageButtonProps> = ({ setIsManagingFilters }) => {
  return (
    <Flex
      align="center"
      gap={8}
      px={36}
      py={10}
      style={{ cursor: 'pointer' }}
      onClick={() => setIsManagingFilters(true)}
    >
      <IconSettings size={18} color={MAIN_DARK_PRIMARY} stroke={1.5} />
      <Text size="sm" c={MAIN_DARK_PRIMARY} fw={500}>
        Manage
      </Text>
    </Flex>
  )
}

export default ManageButton